import { isEmpty } from "lodash";
import { createSelector } from "reselect";

import { keyListFromMap } from "../../../../utils/immutableExtensions";
import { sequenceSelectors } from "../../../sequence";
import getNestedIndexesMap from "./getNestedIndexesMap";

const getSuperDepth = (childrenById, children, depth) => {
  return children.reduce(
    // reducer function
    (depths, id) => {
      depths[id] = depth;
      const superAndChildObj = childrenById.get(id);
      const itemChildren = superAndChildObj ? superAndChildObj.children : null;
      if (itemChildren && itemChildren.size) {
        const newDepths = getSuperDepth(childrenById, itemChildren, depth + 1);
        Object.assign(depths, newDepths);
      }
      return depths;
    },
    // Initial value: empty object
    {}
  );
};

const getSuperDepthById = createSelector(
  // input
  superAndChildrenById => superAndChildrenById,
  // output
  superAndChildrenById => {
    const topLevelIds = keyListFromMap(superAndChildrenById.filter(s => !s.super));
    return getSuperDepth(superAndChildrenById, topLevelIds, 0);
  }
);

// Changes:
//   - sequenceIndex
//   - nestedIndex
//   - superDepth
const applySequenceUpdates = (
  state,
  action,
  newSequence,
  prevSequence,
  newSuperAndChildrenById,
  prevSuperAndChildrenById
) => {
  // If sequence and superAndChildrenById has not changed, do nothing
  if (newSequence === prevSequence && newSuperAndChildrenById === prevSuperAndChildrenById) {
    return state;
  }

  const sequenceIndexById = sequenceSelectors.getSequenceIndexById(newSequence);
  const nestedIndexesById = getNestedIndexesMap(newSuperAndChildrenById, newSequence);
  const superDepthById = getSuperDepthById(newSuperAndChildrenById);

  return state.withMutations(s => {
    s.forEach((itemRec, id) => {
      const sequenceIndex = sequenceIndexById.get(id);
      const nestedIndex = nestedIndexesById[id];
      const superDepth = superDepthById[id];

      let changes = {};
      if (nestedIndex !== itemRec.nestedIndex) {
        changes.nestedIndex = nestedIndex;
      }
      if (sequenceIndex !== itemRec.sequenceIndex) {
        changes.sequenceIndex = sequenceIndex;
      }
      if (superDepth !== itemRec.superDepth) {
        changes.superDepth = superDepth;
      }

      if (!isEmpty(changes)) {
        s.update(id, d => d.merge(changes));
      }
    });
  });
};

export default applySequenceUpdates;
